import { Card, CardHeader, CardTitle } from '@/components/ui/Card';
import type { ClientRecord } from '@/api/clients';
import { fmtDob } from '../clientHelpers';

export function ClientHistoryTab({ client: c }: { client: ClientRecord }) {
    const history = c.history || [];
    if (!history.length) {
        return (
            <Card>
                <p className="text-sm text-text-subtle">No status history yet.</p>
            </Card>
        );
    }
    return (
        <Card className="p-0 overflow-hidden">
            <CardHeader className="px-5 pt-5">
                <CardTitle>Status Changes</CardTitle>
            </CardHeader>
            <div className="overflow-x-auto">
                <table className="w-full text-sm">
                    <thead>
                        <tr className="text-left text-2xs uppercase tracking-wider text-text-subtle border-b border-border">
                            <th className="px-5 py-2 font-bold whitespace-nowrap">Date</th>
                            <th className="px-3 py-2 font-bold">From</th>
                            <th className="px-3 py-2 font-bold">To</th>
                            <th className="px-3 py-2 font-bold">By</th>
                            <th className="px-5 py-2 font-bold">Note</th>
                        </tr>
                    </thead>
                    <tbody>
                        {history.map((h, i) => (
                            <tr key={i} className="border-b border-border last:border-b-0 align-top">
                                <td className="px-5 py-2 text-text-muted whitespace-nowrap">{h.date ? fmtDob(h.date) : '—'}</td>
                                <td className="px-3 py-2 text-text-muted">{h.from || '—'}</td>
                                <td className="px-3 py-2 text-text-muted">{h.to   || '—'}</td>
                                <td className="px-3 py-2 text-text-muted">{h.by   || '—'}</td>
                                <td className="px-5 py-2 whitespace-pre-wrap">{h.note || '—'}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </Card>
    );
}
